import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {User} from '../../../../../auth/models';

@Component({
    selector: 'jft-tender-suppliers-search-bar',
    templateUrl: './tender-suppliers-search-bar.html',
    styleUrls: ['./tender-suppliers-search-bar.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TenderSuppliersSearchBarComponent implements OnInit {

    public term: string;

    @Output()
    private onChanges = new EventEmitter();

    constructor(
        public user: User,
    ) {
    }

    public ngOnInit() {
    }

    public search() {
        this.onChanges.next(this.term);
    }

    public clearTerm() {
        delete this.term;
        this.onChanges.next(this.term);
    }
}
